import * as React from 'react'
import { CarouselCollection } from '../carousel/carouselCollection'
import { ICollection } from '../../selectors/collections'
import { CollectionDetail } from '../../reducers/collections'
import * as st from './bundleCarousel.module.scss'
import * as cn from 'classnames'
import { isTreatment } from '../../utils/utils'

export const BundleCarousel = (bundleCarouselCollection: CollectionDetail) => {
  const collectionProps = {
    header: bundleCarouselCollection.header,
    collectionType: bundleCarouselCollection.collectionType,
    cardTitleIds: bundleCarouselCollection.titleIds,
    totalEpisodeSize: bundleCarouselCollection.totalCardSize,
    refTagPrefix: 'atv_dp_bundle_',
    index: 0
  } as ICollection
  const shouldRender = collectionProps.cardTitleIds && collectionProps.cardTitleIds.length > 0
  const { atfTreatment } = bundleCarouselCollection;

  return shouldRender ? (
    <div className={cn(st.avDpBundleCarousel, {[st.avDpBundleCarouselRedesign]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}>
      <CarouselCollection {...collectionProps} />
    </div>
  ) : null
}